import * as tslib_1 from "tslib";
import { ExecuteActionQuotationInput, GetQuotationAttachmentsQueryResponse, GetQuotationQueryResponse, ListQuotationsQueryResponse, ListQuotationsResult, Quotation, QuotationAttachmentsResponse, QuotationLabelInput, } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import { QuotationQueries } from './quotation.queries';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
import * as i2 from "./quotation.queries";
var QuotationService = /** @class */ (function () {
    function QuotationService(apollo, queries) {
        this.apollo = apollo;
        this.queries = queries;
    }
    QuotationService.prototype.listQuotations = function (_a) {
        var where = _a.where, options = _a.options;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_b) {
                query = this.queries.listQuotations();
                variables = {
                    where: where,
                    orderBy: options.orderBy,
                    limit: options.limit,
                    offset: options.offset,
                };
                return [2 /*return*/, this.apollo.query({ query: query, variables: variables })
                        .toPromise()
                        .then(function (response) {
                        return {
                            items: response.data.quotations.items,
                            totalCount: response.data.quotations.totalCount,
                            filtered: Boolean(where.createdAt_gte ||
                                where.createdAt_lte ||
                                where.agreementAt_gte ||
                                where.agreementAt_lte ||
                                where.total_gte ||
                                where.total_lte ||
                                where.identifier_contains ||
                                where.locationId_in ||
                                where.companyId_in ||
                                where.maintenanceTypeId_in ||
                                where.segmentId_in ||
                                where.locationGroupId_in ||
                                where.approvedByOrRefusedById_in ||
                                where.status_in ||
                                where.archived !== false ||
                                where.maintenanceId_in ||
                                where.labelId_in),
                        };
                    })];
            });
        });
    };
    QuotationService.prototype.getById = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_a) {
                query = this.queries.getQuotationById();
                variables = { id: id };
                return [2 /*return*/, this.apollo.query({
                        query: query,
                        variables: variables
                    }).toPromise()
                        .then(function (response) { return response.data.quotation; })];
            });
        });
    };
    QuotationService.prototype.getAttachments = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query, variables;
            return tslib_1.__generator(this, function (_a) {
                query = this.queries.getQuotationAttachments();
                variables = { id: id };
                return [2 /*return*/, this.apollo.query({
                        query: query,
                        variables: variables
                    }).toPromise()
                        .then(function (response) { return response.data.quotation; })];
            });
        });
    };
    QuotationService.prototype.approveQuotation = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mutation, variables;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mutation = this.queries.approveQuotation();
                        variables = { input: input };
                        return [4 /*yield*/, this.apollo.mutate({ mutation: mutation, variables: variables }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    QuotationService.prototype.rejectQuotation = function (input) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mutation, variables;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mutation = this.queries.rejectQuotation();
                        variables = { input: input };
                        return [4 /*yield*/, this.apollo.mutate({ mutation: mutation, variables: variables }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    QuotationService.prototype.saveQuotationLabels = function (input, isRemove) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mutation, variables;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mutation = isRemove ? this.queries.removeQuotationLabel() : this.queries.addQuotationLabel();
                        variables = { input: input };
                        return [4 /*yield*/, this.apollo.mutate({ mutation: mutation, variables: variables }).toPromise()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    QuotationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function QuotationService_Factory() { return new QuotationService(i0.ɵɵinject(i1.Apollo), i0.ɵɵinject(i2.QuotationQueries)); }, token: QuotationService, providedIn: "root" });
    return QuotationService;
}());
export { QuotationService };
